import type { CodeRuntime, SessionRuntime } from './types';

import { cloudRuntime } from './cloud';
import { localRuntime } from './local/local-runtime';
import { isLocalSessionId } from './session-id';

/**
 * A session in the runtime that runs it. Its conversation, its checkout, its record and its
 * Retry ask here, so a second runtime, sessions on the person's own machine, plugs into
 * those without touching the controller or the rest of the client. The
 * cloud-only features that `CodeRuntime` lists still call the cloud API, so a
 * second runtime also needs capability flags that hide the ones it lacks.
 *
 * This selects cloud-versus-desktop session behavior for clients, not a cloud
 * compute provider. Cloud sandbox construction belongs to
 * `@/lib/code-sessions/sandbox/driver`.
 */
export function runtimeFor(sessionId: string): SessionRuntime {
  return codeRuntimeOf(sessionId).session(sessionId);
}

export function codeRuntimeOf(sessionId: string): CodeRuntime {
  return isLocalSessionId(sessionId) ? localRuntime : cloudRuntime;
}
